import {OperatorModel} from './operator.model';
import {DetaillineDTOModel} from './detaillineDTO.model';
import {MeterReadingDTOModel} from './meter-reading-DTO.model';
import {TimeLoggerDTOModel} from './time-logger-DTO.model';
import {SimpleEngineerBeanModel} from './simple-engineer-bean.model';
import {WsTaskDTOModel} from './ws-task-DTO.model';
import {ContactModel} from './contact.model';
import {CustomerModel} from './customer.model';
import {SiteModel} from './site.model';
import { BinLocationModel } from './bin-location.model';

export class ServiceJobDTOModel {
    public id: number;
    public jobStatus: number;
    public jobNumber: number;
    public operator: OperatorModel;
    public scheduledDate: string;
    public servicedItem: DetaillineDTOModel;
    public tasks: WsTaskDTOModel[];
    public contact: ContactModel;
    public cust: CustomerModel;
    public depot: number;
    public projectId: string;
    public manualRef: number;
    public jobType: string;
    public jobTypeId: number;
    public engineer: SimpleEngineerBeanModel;
    public complete: string; // complete date
    public meterReadings: MeterReadingDTOModel[];
    public timeLogger: TimeLoggerDTOModel[];
    public completedJob: boolean;
    public selectedEngineer: number;
    public jobCertificateTextId: number;
    public freeText: string; // Saved as string
    public noteText: string;
    public site: SiteModel;
    public spares: DetaillineDTOModel[];
    public start: any;
    public isChargeable: boolean;
    public binLocation: BinLocationModel;

    [x: string]: any;
}
